import { render, staticRenderFns } from "./video-select.vue?vue&type=template&id=3d398733&scoped=true"
import script from "./video-select.vue?vue&type=script&lang=js"
export * from "./video-select.vue?vue&type=script&lang=js"
import style0 from "./video-select.vue?vue&type=style&index=0&id=3d398733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d398733",
  null
  
)

export default component.exports